import { Injectable } from '@angular/core';
import { catchError, map, Observable, throwError } from 'rxjs';
import { HttpHaaiBeResponse } from '../interfaces/response.interface';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { BeneficiaryDraft } from '../interfaces/beneficiary.draft.interface';
import { ErrorHandler } from '../handlers/errorHandler';

@Injectable({
  providedIn: 'root'
})
export class BeneficiariosService {
  private readonly API_URL = environment.BORROMEO_API;

  constructor(private http: HttpClient) { }

  public saveClientBeneficiaries(beneficiariesPayload: BeneficiaryDraft[]): Observable<HttpHaaiBeResponse> {
    return this.http.post<HttpHaaiBeResponse>(`${this.API_URL}/beneficiario`, beneficiariesPayload).pipe(
      map((response) => response.result),
      catchError((error) => {
        return throwError(() => ErrorHandler.handleHttpError(error))
      })
    );
  }

  public getClientBeneficiaries(certificateId: string): Observable<HttpHaaiBeResponse> {
    return this.http.get<HttpHaaiBeResponse>(`${this.API_URL}/beneficiario?numeroCertificado=${certificateId}`).pipe(
      map((response) => response.result),
      catchError((error) => {
        return throwError(() => ErrorHandler.handleHttpError(error))
      })
    );
  }

  public requestOtpByEmail(email: string, numeroCertificado: string): Observable<HttpHaaiBeResponse> {
    return this.http.get<HttpHaaiBeResponse>(`${this.API_URL}/notificaciones/enviarOtp?email=${email}&numeroCertificado=${numeroCertificado}`).pipe(
      map((response) => response.result),
      catchError((error) => {
        return throwError(() => ErrorHandler.handleHttpError(error))
      })
    );
  }

  public validateOtp(email: string, otp: string): Observable<HttpHaaiBeResponse> {
    return this.http.get<HttpHaaiBeResponse>(`${this.API_URL}/otp/validarCodigoEmail?email=${email}&codigo=${otp}`).pipe(
      map((response) => response.result),
      catchError((error) => {
        return throwError(() => ErrorHandler.handleHttpError(error))
      })
    );
  }
}
